import Vue from 'vue'
import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import VueRouter from 'vue-router'
import { SET_LOGGED_IN, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },  
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/Login.vue')
  }, 
  {
    path: '/reset-password/',
    name: 'resetpassword',
    component: () => import('../views/Login/ResetPassword.vue')
  },  
  {
    path: '/learningcenter',
    name: 'learningcenter',
    component: () => import('../views/Dashboard/Dashboard.vue'),  
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/Users/Users.vue'),   
  }, 
  {
    path: '/inbox',
    name: 'inbox',
    component: () => import('../views/Inbox/Inbox.vue'),   
  },    
  {
    path: '/equipment',
    name: 'equipment',
    component: () => import('../views/Equipments/Equipments.vue'),   
  },  
  {
    path: '/equipment/edit/:id',
    name: 'editequipment',
    component: () => import('../views/Equipments/addeditEquipments.vue'),  
  },  
  {
    path: '/equipment/add',
    name: 'addequipment',
    component: () => import('../views/Equipments/addeditEquipments.vue'),   
  },     
  {
    path: '/modules',
    name: 'modules',
    component: () => import('../views/Modules/Modules.vue'),   
  }, 
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Login/Register.vue'),   
  },   
  {
    path: '/groups',
    name: 'groups',
    component: () => import('../views/Groups/Groups.vue'),   
  },   
  {
    path: '/groups/edit/:id',
    name: 'editgroups',
    component: () => import('../views/Groups/addeditGroups.vue'),  
  },  
  {
    path: '/groups/add',
    name: 'addgroups',
    component: () => import('../views/Groups/addeditGroups.vue'),   
  },
  {
    path: '/learningmaterial',
    name: 'learningmaterial',
    component: () => import('../views/Documents/Documents.vue'),   
  },
  {
    path: '/courses',
    name: 'courses',
    component: () => import('../views/Courses/Courses.vue'),   
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/Settings/Settings.vue'),   
  },
  {
    path: '/learningmaterial/:id',
    name: 'learningmaterialdetail',
    component: () => import('../views/Documents/DocumentDetail.vue'),   
  },  
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import('../views/Users/Invoices.vue'),   
  }, 
  {
    path: '/forgot-password',
    name: 'forgotpassword',
    component: () => import('../views/Login/ForgotPassword.vue'),
  },     
  {
    path: '/users/edit/:id',
    name: 'editusers',
    component: () => import('../views/Users/addeditUsers.vue'),  
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Users/Profile.vue'),  
  },  
  {
    path: '/users/add',
    name: 'addusers',
    component: () => import('../views/Users/addeditUsers.vue'),   
  },      
  {
    path: '/modules/:id',
    name: 'moduledetails',
    component: () => import('../views/ModuleDetail/ModuleDetail.vue'),  
  }, 
  {
    path: '/moduleplayer/:id',
    name: 'moduleplayer',
    component: () => import('../views/ModulePlayer/ModulePlayer.vue'),  
  },  
  {
    path: '/pages/:slug',
    name: 'pages',
    component: () => import('../views/Pages/Pages.vue'),  
  },      
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
    if(store.getters.isAuthenticated){
      if (JwtService.getToken()) {
        ApiService.setHeader();
        store.commit(SET_ROUTER_ENTER, true)
        store.commit(SET_LOGGED_IN, true)
      }
    }
    if (!['login','forgotpassword','resetpassword','register'].includes(to.name) && !store.getters.isAuthenticated) next({ name: 'login' })
    else next()    


})



export default router
